import { ComponentType } from 'react';

import { SvgIconProps } from '@mui/material/SvgIcon';

import {
  ArmchairIcon,
  CarBatteryIcon,
  CarIcon,
  CraneIcon,
  LightningIcon,
  MonitorOutlineIcon,
  PrinterIcon,
  RouterIcon,
  SmartphoneOutlineIcon,
  ToolIcon,
  TractorIcon,
  TruckIcon,
} from '../../icons';

export type AssetTypeIconKey =
  | 'car'
  | 'truck'
  | 'tractor'
  | 'crane'
  | 'monitor'
  | 'smartphone'
  | 'printer'
  | 'router'
  | 'armchair'
  | 'tool'
  | 'battery'
  | 'lightning';

export type AssetTypeIconColorKey =
  | 'grey'
  | 'brown'
  | 'gold'
  | 'orange'
  | 'volcano'
  | 'red'
  | 'pink'
  | 'purple'
  | 'cyan'
  | 'green';

type IconComponent = ComponentType<SvgIconProps>;

const DEFAULT_ICON: IconComponent = CarIcon;

const ICON_MAP: Record<AssetTypeIconKey, IconComponent> = {
  car: CarIcon,
  truck: TruckIcon,
  tractor: TractorIcon,
  crane: CraneIcon,
  monitor: MonitorOutlineIcon,
  smartphone: SmartphoneOutlineIcon,
  printer: PrinterIcon,
  router: RouterIcon,
  armchair: ArmchairIcon,
  tool: ToolIcon,
  battery: CarBatteryIcon,
  lightning: LightningIcon,
};

const DEFAULT_COLORS = {
  stroke: '#B8BABF',
  fill: '#F3F5F9',
};

const COLOR_MAP: Record<AssetTypeIconColorKey, { stroke: string; fill: string }> = {
  grey: {
    stroke: '#B8BABF',
    fill: '#F3F5F9',
  },
  brown: {
    stroke: '#9D6957',
    fill: '#FFE6D8',
  },
  gold: {
    stroke: '#FFB626',
    fill: '#FFF6D3',
  },
  orange: {
    stroke: '#FA8C16',
    fill: '#FFF7E6',
  },
  volcano: {
    stroke: '#FA541C',
    fill: '#FFF2E8',
  },
  red: {
    stroke: '#DB2E46',
    fill: '#FFE4D8',
  },
  pink: {
    stroke: '#F6427E',
    fill: '#FEE5ED',
  },
  purple: {
    stroke: '#722ED1',
    fill: '#F9F0FF',
  },
  cyan: {
    stroke: '#00C9E3',
    fill: '#E0F7FC',
  },
  green: {
    stroke: '#A0D911',
    fill: '#FCFFE6',
  },
};

export const AVAILABLE_ICON_KEYS = Object.keys(ICON_MAP) as AssetTypeIconKey[];
export const AVAILABLE_COLOR_KEYS = Object.keys(COLOR_MAP) as AssetTypeIconColorKey[];

export function getAssetTypeIconComponent(iconKey?: AssetTypeIconKey): IconComponent {
  if (!iconKey) return DEFAULT_ICON;
  return ICON_MAP[iconKey] ?? DEFAULT_ICON;
}

export function getAssetTypeIconColors(colorKey?: AssetTypeIconColorKey) {
  if (!colorKey) return DEFAULT_COLORS;
  return COLOR_MAP[colorKey] ?? DEFAULT_COLORS;
}
